"use strict";
/*
 * Created on 12 03 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * VendorAllowanceBonusConverter
 *
 * @author JMe
 */


var VendorAllowanceBonusConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(VendorAllowanceBonusConverter, _DataObjectConverter_);

  function VendorAllowanceBonusConverter() {
    _classCallCheck(this, VendorAllowanceBonusConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceBonusConverter).apply(this, arguments));
  }

  return VendorAllowanceBonusConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.VendorAllowanceBonusConverter = VendorAllowanceBonusConverter;